<footer>
  <mat-toolbar>
    <small>{{version}}</small>
  </mat-toolbar>
</footer>